import { useMemo } from 'react'
import { cn } from '@utils'

interface VariantSelectorProps {
  variants: Record<string, string[]>
  selections: Record<string, (string | null)[]>
  expectedQuantity: number
  useQuantityMode?: boolean
  selectedQuantities?: Record<string, any>
  bundleQuantity?: number
  imageUrl?: string
  subtitle?: string
  onSelectionChange: (name: string, index: number, value: string | null) => void
  onQuantityChange?: (variantId: string, qty: number) => void
}

const formatLabel = (name: string): string =>
  name.toLowerCase().replace(/\w\S*/g, w => w[0].toUpperCase() + w.slice(1).toLowerCase())

const VariantSelector = ({
  variants,
  selections,
  expectedQuantity,
  bundleQuantity = 1,
  subtitle,
  onSelectionChange,
}: VariantSelectorProps) => {
  const variantNames = useMemo(() => Object.keys(variants).sort(), [variants])

  const dropdownSelectorCount = useMemo(
    () => (bundleQuantity > 1 ? expectedQuantity : 1),
    [bundleQuantity, expectedQuantity]
  )

  return (
    <div className="variant-selector">
      {subtitle && <p className="subtitle text-fluid-sm">{subtitle}</p>}
      {Array.from({ length: dropdownSelectorCount }).map((_, slotIndex) => (
        <div key={slotIndex} className={cn('slot', dropdownSelectorCount > 1 && 'multi')}>
          {dropdownSelectorCount > 1 && <div className="slot-label text-fluid-sm">Bundle Item {slotIndex + 1}</div>}
          {variantNames.map(name => {
            const fieldId = `variant-${name}-${slotIndex}`
            return (
              <div key={name} className="field">
                <label htmlFor={fieldId} className="text-fluid-sm">
                  {formatLabel(name)}
                  {dropdownSelectorCount > 1 && ` #${slotIndex + 1}`}
                </label>
                <select
                  id={fieldId}
                  className="form-control w-full"
                  required
                  value={selections[name]?.[slotIndex] ?? ''}
                  onChange={e => onSelectionChange(name, slotIndex, e.target.value === '' ? null : e.target.value)}>
                  <option value="">-- Please Select --</option>
                  {variants[name]?.map(value => (
                    <option key={value} value={value}>
                      {value}
                    </option>
                  ))}
                </select>
              </div>
            )
          })}
        </div>
      ))}
    </div>
  )
}

export default VariantSelector
